import { render } from "./DropDownMenuButtonItem.vue?vue&type=template&id=07778d8f"
import script from "./DropDownMenuButtonItem.vue?vue&type=script&lang=js"
export * from "./DropDownMenuButtonItem.vue?vue&type=script&lang=js"

import "./DropDownMenuButtonItem.vue?vue&type=style&index=0&id=07778d8f&lang=css"
script.render = render

export default script